module.exports = __webpack_public_path__ + "img/guide_wave.de7a9022.svg";